import { ActionTree } from 'vuex';
import { GlobalState } from '../types';
import { SessionsState, Session } from './types';

import * as myetaapi from '../../api/myeta';
import moment from 'moment';

export const actions: ActionTree<SessionsState, GlobalState> = {
    async clear({ commit }, payload) {
        await myetaapi.clearSession(payload.sessionId, payload.clear || false);
        commit('sessionCleared', payload.sessionId);
    },

    async arrive({ commit, dispatch }, payload) {
        await myetaapi.completeSession(payload);
        commit('sessionArrived', payload);
    },

    async startSessionTracking({commit, dispatch}, payload) {
        // subscribe to iot and start tracking

        // const mapSession = (p: any) => {
        //     const now = moment();
        //     const etaTime = moment.unix(p.eta);
        //     const validTime = moment.unix(p.validTill);
        //     const duration = moment.duration(etaTime.diff(now));
        //     const validDuration = moment.duration(validTime.diff(now));

        //     let outcome = p.finalized;
        //     if ((!!!outcome) && (now > etaTime)) {
        //         outcome = 'Timed out';
        //     } else if (outcome == 'completed') {
        //         outcome = 'Arrived';
        //     } else if (outcome == 'canceled') {
        //         outcome = 'Canceled';
        //     }

        //     let level = 'GPS';
        //     if (p.etaLevel === 1) {
        //         level = 'Manual';
        //     }

        //     return {
        //         id: p.id,
        //         name: p.metaFields.name,
        //         pet: p.metaFields.pet,
        //         eta: Math.max(0, duration.asMinutes()).toFixed(0),
        //         time: etaTime.format('LT'),
        //         valid: validDuration.asMinutes().toFixed(0),
        //         level,
        //         outcome,
        //     };
        // };

        // const pullSessions = async () => {
        //     commit('setPulling', true);
        //     const sessions = await myetaapi.getSessions(payload);
        //     console.log('pull sessions', sessions);

        //     const recents = await myetaapi.getRecents(payload);
        //     console.log('pull recents', recents);

        //     const currentSessions = (sessions || []).map(mapSession);
        //     const currentRecents = (recents || []).map(mapSession);
    
        //     commit('setSessions', {
        //         sessions: currentSessions,
        //         recents: currentRecents
        //     });
        //     commit('setPulling', false);
        // };

        const timer = setInterval(async ()=> {
            await dispatch('pull');
        }, 60000);
        commit('timerStarted', { timer, destination: payload });

        await dispatch('pull');
        //await pullSessions();
    },

    async pull({ commit, state }) {
        const mapSession = (p: any) => {
            const now = moment();
            const etaTime = moment.unix(p.eta);
            const validTime = moment.unix(p.validTill);
            const duration = moment.duration(etaTime.diff(now));
            const validDuration = moment.duration(validTime.diff(now));

            let outcome = p.finalized;
            if ((!!!outcome) && (now > etaTime)) {
                outcome = 'Unknown';
            } else if (outcome == 'completed') {
                outcome = 'Arrived';
            } else if (outcome == 'canceled') {
                outcome = 'Canceled';
            }

            let level = 'GPS';
            if (p.etaLevel === 1) {
                level = 'Manual';
            }

            return {
                id: p.id,
                name: p.metaFields.name,
                pet: p.metaFields.pet,
                instruct: p.metaFields.instruct || null,
                eta: Math.max(0, duration.asMinutes()).toFixed(0),
                time: etaTime.format('LT'),
                valid: validDuration.asMinutes().toFixed(0),
                level,
                outcome,
            };
        };

        if (state.destination) {
            commit('setPulling', true);
            const sessions = await myetaapi.getSessions(state.destination);
            console.log('pull sessions', sessions);

            const recents = await myetaapi.getRecents(state.destination);
            console.log('pull recents', recents);

            const currentSessions = (sessions || []).map(mapSession);
            const currentRecents = (recents || []).map(mapSession);


            const newSessions = (!state.firstPull && ((state.sessions || []).length < currentSessions.length));

            commit('setSessions', {
                sessions: currentSessions,
                recents: currentRecents
            });
            commit('setPulling', false);

            if (newSessions) {
                commit('newSession', newSessions);
            }
        }
    },

    async stopSessionTracking({commit, state}) {
        console.log('stop timer');
        clearInterval(state.timer);
        commit('timerStopped');
    },
};
